import Api from "@/services/Api";

const state = {
	events: []
};
const getters = {
	getData: state => state.events
};
const mutations = {
	GET_EVENTS(state, payload) {
		Api.get(`event-logs?${payload.url}`)
			.then(resp => {
				state.events = resp.data;
				payload.context.loading = false;
			})
			.catch(err => {
				payload.context.loading = false;
				return err.response.data.message;
			});
	}
};
const actions = {
	ALL_EVENTS({ commit }, { page, context }) {
		commit("GET_EVENTS", {
			url: `page=${page}`,
			context: context
		});
	},
	SUCCESS_EVENTS({ commit }, { page, context }) {
		commit("GET_EVENTS", {
			url: `status=success&page=${page}`,
			context: context
		});
	},
	FAILED_EVENTS({ commit }, { page,  context }) {
		commit("GET_EVENTS", {
			url: `status=failed&page=${page}`,
			context: context
		});
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
